<script setup></script>

<template>
  <div class="loader">
    <img
      class="more-button__spinner"
      src="~/assets/images/spinner.svg"
      alt="loading"
    />
  </div>
</template>

<style scoped lang="postcss">
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & img {
    width: 100px;
    height: 50px;
  }
}
</style>
